import React, { useState, useRef } from "react";
import { AntdButton, DatePickerField, SelectInput } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import { handleKeyDown } from "../../../blueplanitUtils/DatePickerAutoformate";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useSelector } from "react-redux";
import { useEmployeeNames } from "../../../blueplanitUtils/EmployeeNames";
import { addDurations } from "./convertIntoTime";
import { ConvertMsIntoTime } from "./convertIntoTime";
import { GetAllRecords } from "../../../Slices/Thunk/Reports";
import { GetDueDateTemp } from "./autoDueDate";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../Slices/loaderSlice";
import { handleExport } from "./Export";
import { getOptionsByPath } from "../../../utilsdata";

import { Tooltip } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { REPORTS, REPORTS_BILLABLE } from "../../../Dropdownmanager";
export const RecordEmployeeReport = () => {
    const data = useSelector((state) => state.Reports.AllRecords);
    const employeeNames = useEmployeeNames();
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState([]);
    let TotalTime = 0;
    const dropdownRef = useRef(null);
    const Employee = useSelector((state) => state.employee.AllEmployees);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [form, setForm] = useState({})
    const [overalTime, setTime] = useState();
    const startOfMonth = dayjs().startOf("month").toDate();
    const endOfMonth = dayjs().endOf("month").toDate();

    const ReportManagers = [
        ...[...new Set(
            Employee?.map(e => e.reportingTo?.trim()).filter(Boolean)
        )].map(manager => ({ value: manager, label: manager }))
    ];

    const handleInputChange = (e) => {
        const { name, value, firstname, lastname } = e?.target;
        if (name === "employeeName") {
            setForm(prev => ({
                ...prev,
                firstName: firstname || "",
                lastName: lastname || "",
                employeeName: value || "",
            }));
        } else {
            // For other fields, update them normally
            setForm(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };


    const handleDateChange = (date, name) => {
        setForm(prev => ({
            ...prev,
            [name]: date
                ? name === 'to'
                    ? dayjs(date).endOf('day').format("YYYY-MM-DDTHH:mm:ssZ") // send as just date
                    : dayjs(date).startOf('day').format("YYYY-MM-DDTHH:mm:ssZ")
                : null
        }));
    };

    const handleSubmit = async () => {
        try {
            setCurrentPage(1);
            if (Object.keys(form).length > 0) {
                dispatch(setLoader(true))
                const { employeeName, ...updatedForm } = form;
                const dataToInsert = {
                    ...updatedForm,
                    page: 1,
                    loginUserId: loginUser?.id,
                };
                await dispatch(GetAllRecords(dataToInsert));

            }
        } catch (error) {
            dispatch(setLoader(false));
        }

    };
    const handleClear = async () => {
        try {
            setCurrentPage(1);
            dispatch(setLoader(true));

            const val = { startOfMonth, endOfMonth, page: 1, loginUserId: loginUser?.id };
            await dispatch(GetAllRecords(val));
            setForm({});
        } catch (error) {
            dispatch(setLoader(false));
        }
    };
    const exportFormatters = {
        date: val => dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a"),
        dueDate: (val, rec) => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : dayjs(GetDueDateTemp(rec.priority)).format("DD/MM/YYYY h:mm a"),
        completedDate: val => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : "Pending",
        billable: val => ConvertMsIntoTime(val),
        Non_billable: val => ConvertMsIntoTime(val),
        totalTimeSpent: (val, rec) => addDurations(rec.billable, rec.Non_billable),

    };
    useEffect(() => {
        (() => {
            const recordsWithTime = data?.records?.map((record, index) => {
                let billable = 0;
                let Non_billable = 0;
                const employeeInfo = record.employeeInfo && record.employeeInfo.length > 0 ? record.employeeInfo[0] : null;
                const createdByName = employeeInfo ? `${employeeInfo.createdByName}` : "Unknown"; // Fallback to "Unknown" if no name found
                const reportingTo = employeeInfo ? employeeInfo.reportingTo : "Not Assigned"; // Fallback to "Not Assigned" if no reporting info

                if (Array.isArray(record.metaInfo)) {
                    record.metaInfo.forEach(({ startTime, endTime, taskType }) => {
                        let start = Number(startTime);
                        let end = Number(endTime);

                        // If endTime is missing, set start = 0
                        if (!endTime) {
                            start = 0;
                        }
                        if (!isNaN(start) && !isNaN(end)) {
                            const duration = end - start;

                            if (taskType?.toLowerCase().includes("processing") || taskType?.toLowerCase().includes("email")) {
                                billable += duration;
                                TotalTime += billable;
                            } else {
                                Non_billable += duration;
                                TotalTime += Non_billable;
                            }
                        }
                    });
                }

                setTime(TotalTime);

                return {
                    ...record,
                    rowId: `${record.requestId || 'record'}-${index}`,
                    billable,
                    Non_billable,
                    createdByName,
                    reportingTo,
                };
            });

            recordsWithTime?.reverse();
            setTableData(recordsWithTime);

            dispatch(setLoader(false));
        })()
    }, [data?.records,])

    useEffect(() => {
        (async () => {
            try {
                dispatch(setLoader(true))
                const isFormEmpty = Object.keys(form).length === 0;
                let val;

                if (isFormEmpty) {
                    val = {
                        ...form,
                        startOfMonth,
                        endOfMonth,
                        page: currentPage,
                        loginUserId: loginUser?.id,
                    };
                } else {
                    const { employeeName, ...formWithoutName } = form;
                    val = {
                        ...formWithoutName,
                        page: currentPage,
                        loginUserId: loginUser?.id,
                    };
                }

                await dispatch(GetAllRecords(val));

            } catch (error) {
                dispatch(setLoader(false));
            }
        })();

    }, []);

    const columns = [
        {
            title: "From", dataIndex: "from", key: "from", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "To", dataIndex: "to", key: "to", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Request#", dataIndex: "requestId", key: "requestId", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Employee Name", dataIndex: "createdByName", key: "createdByName", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>

        },
        {
            title: "Reporting TO", dataIndex: "reportingTo", key: "reportingTo", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>

        },
        {
            title: "Client Name", dataIndex: "clientName", key: "clientName", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>
        },
        {
            title: "Process Type", dataIndex: "processType", key: "processType", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : 'N/A'
        },
        {
            title: "Request Type", dataIndex: "quoteType", key: "quoteType", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : 'N/A'
        },
        {
            title: "Department", dataIndex: "department", key: "department", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>
        },
        {
            title: "Request Received Date & Time", dataIndex: "date", key: "date", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a")}</div>
        },
        {
            title: "Request Due Date & Time", dataIndex: "dueDate", key: "dueDate", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: (text, record) => <div>{text ? dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a") : dayjs(GetDueDateTemp(record.priority)).format('DD/MM/YYYY h:mm a')}</div>
        },
        {
            title: "Completed Date & Time", dataIndex: "completedDate", key: "completedDate", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{text ? dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a") : 'Pending'}</div>
        },
        {
            title: "Number of Time Records", dataIndex: "historyCount", key: "historyCount", align: "center", width: 160,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : '0'
        },
        {
            title: "Number of Transactions", dataIndex: "noofQuotes", key: "noofQuotes", align: "center", width: 160,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : '0'
        },
        {
            title: "Billable Time", dataIndex: "billable", key: "billable", align: "center", width: 130,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{ConvertMsIntoTime(text)}</div>
        },
        {
            title: "Non-Billable Time", dataIndex: "Non_billable", key: "Non_billable", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{ConvertMsIntoTime(text)}</div>
        },
        {
            title: "Total Time Spent on WO", dataIndex: "totalTimeSpent", key: "totalTimeSpent", align: "center",
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: (text, record) => <div>{addDurations(record.billable, record.Non_billable)}</div>
        },

    ];

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const columnKeys = columns?.map(col => col.key); // these are the keys like "from", "to", etc.
    const selectedColumns = columnKeys; // use this for both header and row values

    const formattedData = tableData?.map(record => {
        const row = {};
        columns?.forEach(col => {
            let value;

            if (exportFormatters[col.dataIndex]) {
                value = exportFormatters[col.dataIndex](record[col.dataIndex], record);
            } else {
                value = record[col.dataIndex];
            }

            row[col.key] = value || '-'; // use col.key for consistent headers
        });
        return row;
    });

    return (
        <div className="page-wrapper px-4">
            <div className="row align-items-center">
                <div className="custom-col-1-5 ">
                    <DatePickerField
                        label="From"
                        classname="form-control"
                        name="from"
                        placeholder="Request RecivedDate"
                        value={form?.from ? dayjs(form.from) : null}
                        format="DD/MM/YYYY"
                        onChange={(date) => handleDateChange(date, "from")}
                        onKeyDown={handleKeyDown}
                        disabledDate={(current) => {
                            return (
                                current &&
                                (current > dayjs(form.to).startOf('day') || current > dayjs().endOf('day'))
                            );
                        }}

                    />
                </div>
                <div className="custom-col-1-5 ">
                    <DatePickerField
                        label="To"
                        classname="form-control"
                        name="to"
                        placeholder="Request DueDate"
                        value={form?.to ? dayjs(form.to) : null}
                        format="DD/MM/YYYY"
                        onChange={(date) => handleDateChange(date, "to")}
                        onKeyDown={handleKeyDown}
                        disabledDate={(current) => {
                            return current && current < dayjs(form.from).startOf('day');
                        }}
                    />
                </div>
                <div className="col-md-3 mb-2 mt-3">
                    <SelectInput
                        formControl={true}
                        label="Employee Name"
                        name="employeeName"
                        placeholder="Employee Name"
                        value={form?.employeeName || []}
                        onChange={(selectedValues, rec) => {
                            handleInputChange({
                                target: {
                                    name: "employeeName",
                                    value: selectedValues,
                                    firstname: rec.firstname,
                                    lastname: rec.lastname,
                                }
                            });
                        }}
                        options={employeeNames}  // Make sure employeeNames is an array of objects with a 'label' (string) and 'value' (object)
                        style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    />
                </div>
                <div className="custom-col-1-5 mb-2 mt-3">
                    <SelectInput
                        formControl={true}
                        label="Billable"
                        name="Billable"
                        placeholder="Billable"
                        value={form?.billable || []}
                        onChange={(selectedValues) =>
                            handleInputChange({
                                target: {
                                    name: "billable",
                                    value: selectedValues,
                                },
                            })
                        }
                        options={getOptionsByPath(NestedDatabucket, [REPORTS, REPORTS_BILLABLE])}

                        style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    />
                </div>
                <div className="col-md-2 mb-2 mt-3">
                    <SelectInput
                        formControl={true}
                        label="Reporting To"
                        name="reportingTo"
                        placeholder="Reporting To"
                        value={form?.reportingTo || []} // Ensure it's always an array
                        onChange={(selectedValues) =>
                            handleInputChange({
                                target: {
                                    name: "reportingTo",
                                    value: selectedValues, // Extract only values
                                },
                            })
                        }
                        options={ReportManagers}
                        style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    />

                </div>

                <div className="col-md-3 mb-1 d-flex justify-content-end gap-2 mt-2">
                    <Tooltip title="Sync Now">
                        <FontAwesomeIcon
                            icon={faSync}
                            style={{
                                fontSize: '24px',
                                color: '#1890ff',
                                cursor: 'pointer',
                                marginRight: '7px',
                                marginTop: '7px',  // moves icon a bit down
                            }}
                            onClick={handleClear}
                        />
                    </Tooltip>
                    <AntdButton variant="outlined" size="medium" label="Search" type="primary" onClick={handleSubmit} style={{
                        backgroundColor: "#007bff",
                        color: "white"
                    }} />
                    <AntdButton variant="outlined" size="medium" label="Clear" onClick={handleClear} type="primary" style={{
                        backgroundColor: "#837F7F",
                        color: "white"
                    }} />
                    <AntdButton
                        onClick={toggleDropdown}
                        type="primary"
                        label="Export"
                        size="medium"
                    />
                    {dropdownOpen && (
                        <ul
                            ref={dropdownRef}
                            className="dropdown-menu show"
                            style={{ display: "block", position: "absolute" }}
                        >
                            <li>
                                <AntdButton
                                    label="CSV"
                                    className="dropdown-item"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleExport("CSV", selectedColumns, formattedData);
                                    }}
                                />
                            </li>
                            <li>
                                <AntdButton
                                    label="PDF"
                                    className="dropdown-item"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleExport("PDF", selectedColumns, formattedData);
                                    }}
                                />
                            </li>
                        </ul>
                    )}
                </div>
            </div>
            <div className="mt-4">
                <CustomGridTable
                    columns={columns}
                    Id="record-employee-report-table"
                    dataSource={tableData}
                    rowKey="rowId"
                    pagination={{
                        current: currentPage,
                        onChange: (page) => setCurrentPage(page),
                        pageSize: 100,
                        total: data?.totalCount,
                        showSizeChanger: false
                    }}
                    scroll={{ x: 1000 }}
                    footer={() => (
                        <div>
                            <strong>Total Duration: </strong>{" "}
                            {ConvertMsIntoTime(overalTime)}
                        </div>
                    )}
                    size="small"
                />
            </div>
            <style>
                {`
                 .custom-col-1-5 {
                width: 11%;
                 }
               
                `}
            </style>
        </div>
    )
}